module.exports = __webpack_public_path__ + "media/images/LED-1-87ed5ce392e1c3fb6472c437254f7e18.png";